import { IDefineCommand } from 'core-ts-types';
import { IAPPlannedCourseDataSource } from '../../../datasources/ap_planned_course_datasource';

angular
  .module('capability-ng-academic-planner')
  .service(
    'toggleLockCourseCommand',
    function toggleLockCourseCommand(
      defineCommandORM: IDefineCommand,
      ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
      $http: ng.IHttpService
    ) {
      return defineCommandORM(
        'toggleLockCourseCommand',
        (deferred: any, plannedCourseID: number, isLocked: boolean = true) => {
          $http
            .put(`/academicplan/suggested_course/${plannedCourseID}`, {
              is_locked: isLocked
            })
            .then((response: any) => {
              const plannedCourse = ngAPPlannedCoursesDatasource.get(response.data.id);

              if (plannedCourse) {
                plannedCourse.is_locked = response.data.is_locked;
                ngAPPlannedCoursesDatasource.put(plannedCourse);
              }

              deferred.resolve();
            })
            .catch((e: any) => {
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_lock_dialog/commands/course_toggle_lock_comand.ts